import React, { useState, useEffect } from "react";

const Input = ({ data, type, name, max, callback }) => {
  const [inputValue, setValue] = useState(data[name]);
  const [error, setError] = useState(false);

  useEffect(() => {
    setValue(data[name]);
  }, []);

  const validate = (value) => {
    if (value > max) {
      setError(true);
      setValue(value);
      data[name] = value;
    } else if (value < 0) {
      setValue(0);
      data[name] = 0;
    } else {
      setValue(value);
      data[name] = value;
      setError(false);
    }
    if (typeof callback === "function") callback(value);
  };

  return (
    <input
      type={type}
      name={name}
      value={inputValue}
      className={error ? "error" : ""}
      onChange={({ target: { value } }) => validate(value)}
    />
  );
};

export default Input;
